const AdditionalImage = require("./additional_image.coffee")

export class InstallShot extends AdditionalImage {}
